import { MerchantCouponUIState } from '../data/merchantCouponEditor.data';
import {
    validateMerchantCouponSchema,
    type MerchantCouponValidationResult,
} from '../schemas/merchantCouponEditor.schema';

export type ValidationResult = MerchantCouponValidationResult;

export const validateMerchantCoupon = (data: MerchantCouponUIState): ValidationResult =>
    validateMerchantCouponSchema(data);

export const formatDateForInput = (dateString: string | null): string => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
};

export const parseDateFromInput = (dateString: string): string | null => {
    if (!dateString) return null;
    const parts = dateString.split('/');
    if (parts.length !== 3) return null;
    const [day, month, year] = parts;
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    if (isNaN(date.getTime())) return null;
    return date.toISOString();
};

export const calculateCostSummary = (coupon: MerchantCouponUIState) => {
    return {
        totalCoupons: coupon.total_quantity_available || 0,
        discountValue: coupon.discount_type === 'percentage' 
            ? `${coupon.discount_value}%`
            : `$${coupon.discount_value}`,
        campaignPeriod: coupon.start_date && coupon.end_date
            ? `${formatDateForInput(coupon.start_date)} - ${formatDateForInput(coupon.end_date)}`
            : '-',
    };
};
